import React from 'react';
import IconResolverContext from '../context/IconResolverContext';
export default function useIconResolver() {
    return React.useContext(IconResolverContext);
}
//# sourceMappingURL=UseIconResolver.js.map